import { ReactNode } from "react"

import { ReleaseReadModel } from "featureFlags/domain/release"
import { CurrentRegionRelease } from "featureFlags/features/getRelease/currentRegionRelease"
import { ReleaseReadModelFactory } from "featureFlags/features/getRelease/factory"
import {
  CurrentRegion,
  EnvCurrentRegion
} from "regionalisation/features/getRegion"

interface ReleaseBasedOnRegionProps {
  flagName: string
  ReleasedComponent: ReactNode
  UnreleasedComponent: ReactNode
  releaseReadModel?: ReleaseReadModel
  currentRegion?: CurrentRegion
}

const ReleaseBasedOnRegion = ({
  flagName,
  ReleasedComponent,
  UnreleasedComponent,
  releaseReadModel = new ReleaseReadModelFactory().build(),
  currentRegion = new EnvCurrentRegion()
}: ReleaseBasedOnRegionProps) => {
  const releases = new CurrentRegionRelease(releaseReadModel, currentRegion)

  if (releases.isLiveInCurrentRegion(flagName)) {
    return ReleasedComponent
  } else {
    return UnreleasedComponent
  }
}

export default ReleaseBasedOnRegion
